import { createSlice } from '@reduxjs/toolkit'
import {
  usersBatchActionsStatusResetAlertHandler,
  getUsersBatchActionsStatusList,
  getUsersBatchActionsStatusListRefreshBtn,
  changeStatusProcessActionsStatusList,
  getFilterUsersBatchActionsStatusList,
} from './usersBatchActionsStatusThunk'
import { objNotEmpty, updateStateFromQueries } from '../../../utils/helpers'

const defaultPageSize = 10
const defaultActiveSummary = 'ALL'

const initialState = {
  loading: {
    fetch: false,
    mutate: false,
  },
  alert: {},
  pageNumber: 0,
  summaries: {},
  activeSort: {},
  sortBy: [],
  filterList: [],
  activeFilters: {
    types: [],
    status: [],
  },
  pageSize: defaultPageSize,
  activeSummary: defaultActiveSummary,
  activeSearch: '',
  data: [],
  lookups: {},
  updatedItem: {},
  sideBar: {},
  finalPage: true,
}

const usersBatchActionsStatusSlice = createSlice({
  name: 'usersBatchActionsStatus',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(usersBatchActionsStatusResetAlertHandler.fulfilled, (state) => {
        state.alert = {}
      })
      .addCase(getUsersBatchActionsStatusList.pending, (state, { meta: { arg: { queries } } }) => {
        state.loading.fetch = true
        state.alert = {}
        state.pageNumber = queries?.pageNumber ? queries?.pageNumber : 0
        if (!queries?.pageNumber) {
          state.data = []
        }
      })
      .addCase(getUsersBatchActionsStatusList.rejected, (state, { payload }) => {
        state.loading.fetch = false
        state.alert = payload
      })
      .addCase(getUsersBatchActionsStatusList.fulfilled, (state, { payload }) => {
        const { response, queries } = payload
        state.data = response?.process
        state.pageNumber = 0
        state.loading.fetch = false
        state.summaries = response?.metadata
        state.filterList = response?.facets
        state.sortBy = response?.sort
        state.alert = {}
        state.finalPage = response?.process?.length < state.pageSize
        updateStateFromQueries(state, queries)
        state.activeSort =
        (objNotEmpty(state.activeSort) && state.pageNumber >= 1)
          ? state.activeSort : response?.sort?.[0]
      })
      .addCase(changeStatusProcessActionsStatusList.pending, (state) => {
        state.loading.mutate = true
        state.alert = {}
      })
      .addCase(changeStatusProcessActionsStatusList.rejected, (state, { payload }) => {
        state.loading.mutate = false
        state.alert = payload
      })
      .addCase(changeStatusProcessActionsStatusList.fulfilled, (state) => {
        state.loading.mutate = false
        state.alert = {}
      })
      .addCase(getUsersBatchActionsStatusListRefreshBtn.pending, (state) => {
        state.loading.fetch = true
        state.alert = {}
        state.data = []
      })
      .addCase(getUsersBatchActionsStatusListRefreshBtn.rejected, (state, { payload }) => {
        state.loading.fetch = false
        state.alert = payload
      })
      .addCase(getUsersBatchActionsStatusListRefreshBtn.fulfilled, (state, { payload }) => {
        state.data = payload.process
        state.loading.fetch = false
        state.alert = {}
      })
      .addCase(getFilterUsersBatchActionsStatusList.pending, (state) => {
        state.loading.fetch = true
        state.alert = {}
        state.data = []
      })
      .addCase(getFilterUsersBatchActionsStatusList.rejected, (state, { payload }) => {
        state.loading.fetch = false
        state.alert = payload
      })
      .addCase(getFilterUsersBatchActionsStatusList.fulfilled, (state, { payload }) => {
        state.activeFilters = payload.filters
        state.data = payload.response.process
        state.summaries = payload.response?.metadata
        state.finalPage = payload.response?.process?.length < state.pageSize
        state.pageNumber = 0
        state.loading.fetch = false
        state.alert = {}
      })
  },
})

export const selectUsersBatchActionsStatus =
({ usersBatchActionsStatus }) => usersBatchActionsStatus
export default usersBatchActionsStatusSlice.reducer
